var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 41.741 43.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "inventory",
    transform: "translate(-24 496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M145.551-495.774c-.281.272-.281.407.036,1.648l.263,1.014-3.911.027-3.9.027-.57.308a2.635,2.635,0,0,0-1.267,1.313l-.244.462-.027,6.174-.027,6.183h1.458l.018-6.056c.027-5.957.027-6.066.217-6.31a2.47,2.47,0,0,1,.435-.435c.235-.181.389-.19,2.689-.217l2.435-.027v1.457h-1.946c-1.955,0-1.955,0-2.173.226l-.226.217v11.144h1.448v-10.14h17.382v11.588h1.448v-12.593l-.226-.217c-.217-.226-.217-.226-2.173-.226H154.74v-1.448h2.309c2.6,0,2.743.027,3.178.6l.263.335.027,6.419.018,6.41h1.458l-.027-6.545-.027-6.536-.244-.462a2.635,2.635,0,0,0-1.267-1.313l-.57-.308-3.9-.027-3.911-.027.263-1.014c.317-1.24.317-1.376.036-1.648l-.217-.226h-6.355Zm5.106,2.236c-.317,1.249-.317,1.385-.036,1.657.208.217.263.226,1.449.226h1.222v1.448H144.6v-1.448h1.222c1.186,0,1.24-.009,1.449-.226.281-.272.281-.407-.036-1.657l-.263-1.014h3.947Z",
    transform: "translate(-101.77 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M200.205-399.795c-.226.217-.226.235-.226,1.946,0,2.327-.154,2.173,2.173,2.173s2.173.154,2.173-2.173.154-2.173-2.173-2.173C200.441-400.021,200.422-400.021,200.205-399.795Zm2.671,1.946v.724h-1.448v-1.449h1.448Z",
    transform: "translate(-160.045 -87.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M264-399.276v.724h1.448V-400H264Z",
    transform: "translate(-218.273 -87.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M296-399.276v.724h5.794V-400H296Z",
    transform: "translate(-247.376 -87.309)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M264-367.276v.724h8.691V-368H264Z",
    transform: "translate(-218.273 -116.412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M200.205-327.795c-.226.217-.226.235-.226,1.946,0,2.327-.154,2.173,2.173,2.173s2.173.154,2.173-2.173.154-2.173-2.173-2.173C200.441-328.021,200.422-328.021,200.205-327.795Zm2.671,1.946v.724h-1.448v-1.448h1.448Z",
    transform: "translate(-160.045 -152.77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M264-327.276v.724h1.448V-328H264Z",
    transform: "translate(-218.273 -152.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M296-327.276v.724h5.794V-328H296Z",
    transform: "translate(-247.376 -152.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M264-295.276v.724h8.691V-296H264Z",
    transform: "translate(-218.273 -181.894)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M220.584-285.951l-9.823,2.942-.634.579c-1.838,1.657-2.127,1.974-2.127,2.281,0,.57.208.67,2.191,1.014l1.783.3,3.513-1.05c1.928-.579,5.5-1.639,7.921-2.363s4.427-1.322,4.463-1.322a2.562,2.562,0,0,1,.027.742l-.027.751-2.444.724a20.129,20.129,0,0,0-2.426.824c.027.154.326,1.258.344,1.286.036.036,5.5-1.593,5.712-1.711.335-.172.38-.416.317-1.783-.045-1.1-.036-1.295.081-1.322.072-.027.688-.208,1.358-.416,1.141-.353,1.249-.407,1.648-.815a2.112,2.112,0,0,0-1.521-3.612C230.515-288.9,228.5-288.323,220.584-285.951Zm10.837-1.313a.722.722,0,0,1,.045.96,3.531,3.531,0,0,1-.932.407c-1.276.389-1.222.389-1.295.054a5.151,5.151,0,0,1-.054-.724V-287l.706-.226C230.787-287.508,231.149-287.517,231.42-287.264Zm-3.639,1.394a2.047,2.047,0,0,1-.009.76c-.081.063-10.981,3.35-11.144,3.35a4.8,4.8,0,0,1-.444-1.331c.027-.027,11.389-3.449,11.479-3.458A2.28,2.28,0,0,1,227.781-285.87Zm-12.81,3.848a1.566,1.566,0,0,1,.118.715c-.036.036-.788.272-1.657.534l-1.593.471-.706-.145a5.813,5.813,0,0,1-.742-.163,3.288,3.288,0,0,1,.5-.552l.534-.525,1.566-.48c.869-.263,1.621-.489,1.684-.489S214.862-282.375,214.971-282.022Z",
    transform: "translate(-167.342 -188.349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M24.226-287.774l-.226.217v23.737l.226.217.217.226H51.078l.217-.226.226-.217v-12.149l-.226-.217-.217-.226H38.485v-11.144l-.226-.217L38.041-288h-13.6Zm4.119,3.169c0,1.955,0,1.955.226,2.173l.217.226H33.7l.217-.226c.226-.217.226-.217.226-2.173v-1.946h2.9v10.139H25.448v-10.139h2.9Zm4.345-.5v1.448h-2.9v-2.9h2.9Zm-4.345,12.086c0,1.955,0,1.955.226,2.173l.217.226H33.7l.217-.226c.226-.217.226-.217.226-2.173v-1.946h2.9v10.14H25.448v-10.14h2.9Zm4.345-.5v1.449h-2.9v-2.9h2.9Zm8.691.5c0,1.955,0,1.955.226,2.173l.217.226h4.907l.217-.226c.226-.217.226-.217.226-2.173v-1.946h2.9v10.14H38.485v-10.14h2.9Zm4.345-.5v1.449h-2.9v-2.9h2.9Z",
    transform: "translate(0 -189.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M136-191.276v.724h1.449V-192H136Z",
    transform: "translate(-101.86 -276.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M136-63.276v.724h1.449V-64H136Z",
    transform: "translate(-101.86 -392.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M280-63.276v.724h1.449V-64H280Z",
    transform: "translate(-232.824 -392.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M349.776-172.478c-.027,3.4-.036,3.54-.217,3.775a2.467,2.467,0,0,1-.435.435c-.235.181-.389.19-2.689.217l-2.435.027v1.448l2.562-.027,2.553-.027.57-.308a2.635,2.635,0,0,0,1.267-1.313l.244-.462.027-3.648.027-3.639H349.8Z",
    transform: "translate(-291.03 -291.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M346.9-165.827v2.173H344v1.449h1.946c1.956,0,1.956,0,2.173-.226l.226-.217V-168H346.9Z",
    transform: "translate(-291.03 -298.306)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.1d6c7b5e240766e7b2bed5fb30f8f93b.svg";
export { ForwardRef as ReactComponent };